import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Helper } from '../shared/helper';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private helper: Helper) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.helper.user_details) {
      const headers = request.headers
        .set('admin_id', this.helper.user_details._id)
        .set('token', this.helper.user_details.token)
        .set('type', '1');
      
      const authReq = request.clone({ headers });
      return next.handle(authReq);
    }
    return next.handle(request);
  }
}
